import React from 'react';

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Empty State 컴포넌트 (귀여운 빈 상태 표시)
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="text-center py-16 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl">
      <div className="text-7xl mb-4 animate-bounce">{icon}</div>
      <h3 className="text-xl font-bold text-gray-700 mb-2">{title}</h3>
      <p className="text-base text-gray-500 mb-6 max-w-md mx-auto px-4">
        {description}
      </p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="btn-primary px-6 py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

/**
 * 로또 Empty State (진행 중인 로또 없음)
 */
export const EmptyLotto: React.FC<{ isAdmin: boolean; onCreateClick?: () => void }> = ({
  isAdmin,
  onCreateClick,
}) => {
  return (
    <EmptyState
      icon="🎲"
      title="진행 중인 로또가 없어요"
      description={
        isAdmin
          ? "새로운 로또를 생성해서 팀원들에게 행운의 기회를 주세요!"
          : "관리자가 곧 새로운 로또를 열어줄 거예요. 조금만 기다려주세요!"
      }
      actionLabel={isAdmin ? "새 로또 생성하기" : undefined}
      onAction={isAdmin ? onCreateClick : undefined}
    />
  );
};

/**
 * 교대 Empty State (교대 신청 없음)
 */
export const EmptySwap: React.FC<{ onCreateClick?: () => void }> = ({ onCreateClick }) => {
  return (
    <EmptyState
      icon="🤝"
      title="아직 교대 신청이 없어요"
      description="근무일을 바꾸고 싶으신가요? 첫 번째 교대 신청자가 되어보세요!"
      actionLabel="교대 신청하기"
      onAction={onCreateClick}
    />
  );
};

/**
 * 휴무 Empty State (휴무 신청 없음)
 */
export const EmptySchedule: React.FC = () => {
  return (
    <EmptyState
      icon="📅"
      title="신청 내역이 없어요"
      description="달력에서 날짜를 클릭해서 휴무를 신청해보세요!"
    />
  );
};

/**
 * 알림 Empty State (알림 없음)
 */
export const EmptyNotification: React.FC = () => {
  return (
    <EmptyState
      icon="🔔"
      title="알림이 없어요"
      description="새로운 알림이 오면 여기에 표시됩니다!"
    />
  );
};

/**
 * 검색 결과 Empty State
 */
export const EmptySearch: React.FC = () => {
  return (
    <EmptyState
      icon="🔍"
      title="검색 결과가 없어요"
      description="다른 키워드로 검색해보세요!"
    />
  );
};
